import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';
import {DateRangePicker} from '../common/SelectDateRange';
import {camelObj} from '../common/ConversionMethod';

export default function KeyActivitiesAdmin() {
	const {dataSource, setDataSource, setCopyDataSource, setCurrentItem, copyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/home/api!organizationKeyActivity.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const detailClick = (item) => {
		// 将数据改成驼峰形式保存在 currentItem 中，方便详情页审核提交用
		setCurrentItem(camelObj(item));
		window.open(Arguments.reactUrl + '/activity/key-activity-admin/detail', '_self');
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 90,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '社会组织',
			dataIndex: 'organization_name',
			width: 130,
		},
		{
			title: '活动名称',
			dataIndex: 'activity_name',
			width: 140,
		},
		{
			title: '主办单位',
			dataIndex: 'activity_unit',
			width: 140,
		},
		{
			title: '活动时间',
			dataIndex: 'activity_date',
			width: 110,
			sorter: (a, b) => new Date(a.activity_date) - new Date(b.activity_date),
			sortDirections: ['ascend', 'descend', 'ascend'],
		},
		{
			title: '活动形式',
			responsive: ['lg'],
			dataIndex: 'activity_form',
			width: 110,
		},
		{
			title: '活动规模（人）',
			responsive: ['lg'],
			dataIndex: 'activity_scope',
			width: 100,
		},
		{
			title: '活动地址',
			dataIndex: 'activity_address',
			width: 140,
		},
		{
			title: '成果形式',
			responsive: ['lg'],
			width: 110,
			dataIndex: 'activity_outcome',
		},
		{
			title: '操作',
			width: 80,
			render: (item) => (
				<Button type="link" onClick={() => detailClick(item)}>详情</Button>
			),
		},
	];

	const indexDataSource = dataSource.map(
		(data, index) => ({showIndex: index + 1, ...data, activity_memo: data.activity_memo?.substring(0, 32000)}));

	const newData = indexDataSource.map(
		(
			{
				organization_name,
				activity_name,
				activity_unit,
				activity_date,
				activity_form,
				activity_scope,
				activity_address,
				activity_outcome,
				activity_subject,
				is_part,
				check_status,
				activity_memo,
			},
		) => (
			{
				'社会组织': organization_name,
				'活动名称': activity_name,
				'主办单位': activity_unit,
				'活动时间': activity_date,
				'活动形式': activity_form,
				'活动规模': activity_scope,
				'活动地点': activity_address,
				'成果形式': activity_outcome,
				'活动主题': activity_subject,
				'是否分会场': is_part,
				'审核状态': check_status,
				'活动说明': activity_memo,
			}
		),
	);

	return (
		<>
			<ExportToExcel tableData={newData}/>
			<DateRangePicker dataSource={dataSource} setDataSource={setDataSource} copyDataSource={copyDataSource}/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}


